import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { statusOptions } from '@constants/masterData';
import useBasicForm from '@hooks/useBasicForm';
import useTranslate from '@hooks/useTranslate';
import { BaseForm, TextField } from '@itz/react-cms-element';
import { Card, Col, Row } from 'antd';

const AreaForm = ({ formId, actions, dataDetail, onSubmit, setIsChangedFormValues, isEditing, deviceId: deviceIdProp }) => {
    const translate = useTranslate();
    const statusValues = translate.formatKeys(statusOptions, ['label']);

    const { form, mixinFuncs, onValuesChange } = useBasicForm({
        onSubmit,
        setIsChangedFormValues,
    });

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const deviceId = deviceIdProp ?? queryParams.get('deviceId');
    const handleSubmit = (values) => {
        return mixinFuncs.handleSubmit({ ...values, deviceId });
    };

    useEffect(() => {
        form.setFieldsValue({
            ...dataDetail,
        });
    }, [dataDetail]);

    useEffect(() => {
        if (!isEditing) {
            form.setFieldsValue({
                status: statusValues[0].value,
            });
        }
    }, [isEditing]);

    return (
        <BaseForm size={500} id={formId} onFinish={handleSubmit} form={form} onValuesChange={onValuesChange}>
            <Card className="card-form" bordered={false}>
                <Row gutter={10}>
                    <Col span={24}>
                        <TextField required label={<FormattedMessage defaultMessage="Area name" />} name="name" />
                    </Col>
                </Row>
                <div className="footer-card-form">{actions}</div>
            </Card>
        </BaseForm>
    );
};

export default AreaForm;
